<template>
  <div class="home">
    <Header></Header>
    <div class="banner">
      <div class="banner-content">
        <div class="left-banner">
          <div class="title">领先的雾计算平台</div>
          <div class="content">
            沐桦科技集合覆盖广泛、部署分散、连接稳定的规模级雾计算节点，拥有海量雾计算设备的IP及算力、存储、带宽等资源，将全球包括现有云计算、企业数据中心及个人PC、终端设备的CPU/GPU/带宽等资源有效连接，提供超低价、超大范围、超强算力的可信任的雾计算服务。</div>
          <div class="know-more cursor-point">
            <router-link to="/dynamic">了解更多</router-link>
          </div>
        </div>
        <div class="right-banner">
          <img
            src="./../assets/home/banner.png"
            alt="沐桦科技"
          />
        </div>
      </div>
    </div>
    <div class="partner blue-back">
      <a
        class="partner-each"
        target="_black"
        href="http://www.aii-alliance.org/lb/20210309/4604.html"
      >
        <img
          src="./../assets/admin/industry.png"
          class="industry"
          alt="工业互联网产业联盟"
        >
        <span>成员单位</span>
      </a>

      <a
        class="partner-each"
        target="_black"
        href="http://www.ecconsortium.org"
      >
        <img
          src="./../assets/admin/compute.png"
          class="compute"
          alt="边缘计算"
        >
        <span>理事单位</span>
      </a>
    </div>
    <div class="news blue-background">
      <!-- basic-wrap -->
      <section class="">
        <div
          data-v-fae5bece=""
          class="muhua-title advantage-title"
        >新闻动态</div>
        <swiper
          :options="swiperOption"
          ref="mySwiper"
          @someSwiperEvent="swiperMethod"
          class="swiper-wrap"
        >
          <!-- slides -->
          <swiper-slide class="news-swiper">
            <div class="one-item">
              <a href="http://it.cri.cn/20191203/d0a9760c-21ad-fa18-6246-24bda4a6e057.html" target="_blank">
              <div class="new-item">
                <div class="new-left">
                  <img
                    src="./../assets/home/news/3.png"
                    class="news-image"
                  >
                </div>
                <div class="new-right">
                  <div class="news-title">业界大咖聚首上海论剑数字化转型新机遇 沐桦科技泛载雾计算助力产业升级与变革</div>
                  <div class="news-content">2019年伴随着工信部发放5G牌照,5G应用陆续落地。云桌面、云存储、容器云等作为5G时代的典型应用,将随着5G网络的大带宽、低延时、泛连接等特点赋能企业数字化转型,带来全新的机遇。[更多]</div>
                </div>
              </div>
              </a>
              <a href="https://henan.qq.com/a/20190823/006564.htm" target="_blank">
                <div class="new-item">
                  <div class="new-left">
                    <img
                      src="./../assets/home/news/1.jpg"
                      class="news-image"
                    >
                  </div>
                  <div class="new-right">
                    <div class="news-title">沐桦科技出席“电信天翼云生态行” 与福建电信达成战略合作</div>
                    <div class="news-content">8月20日，电信天翼云生态行——甄选商城发布会在福建厦门开幕。沐桦科技出席“电信天翼云生态行” 与福建电信达成战略合作，共同开启天翼云生态开放服务的新篇章。[更多]</div>
                  </div>
                </div>
              </a>
            </div>
          </swiper-slide>
          <!-- Optional controls -->
          <div
            class="swiper-pagination"
            slot="pagination"
          ></div>
          <div
            class="swiper-button-prev"
            slot="button-prev"
          ></div>
          <div
            class="swiper-button-next"
            slot="button-next"
          ></div>
          <!-- <div class="swiper-scrollbar"   slot="scrollbar"></div> -->
        </swiper>
      </section>
    </div>
    <section class="compute-wrap">
      <div class="muhua-title">多种分布式计算能力</div>
      <div class="compute-content">
        <div class="card-wrap">
          <div class="card">
            <img src="./../assets/home/compute.png">
            <div class="title">雾计算</div>
            <router-link to="/compute">了解更多</router-link>
          </div>
        </div>
        <!-- <div class="card-wrap">
          <div class="card">
            <img src="./../assets/home/agent.png">
            <div class="title">高质量动态代理</div>
            <router-link to="/dynamic">了解更多</router-link>
          </div>
        </div> -->
        <div class="card-wrap">
          <div class="card">
            <img src="./../assets/home/cache.png">
            <div class="title">分布式存储</div>
            <router-link to="/cache">了解更多</router-link>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img src="./../assets/home/edge.png">
            <div class="title">数据通道</div>
            <router-link to="/dataChanel">了解更多</router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="advantage-wrap">
      <div class="muhua-title advantage-title">核心优势</div>
      <div class="card-content">
        <!-- <div class="card-wrap">
          <div class="card">
            <img src="./../assets/home/speed.png">
            <div class="card-title ">高可用</div>
          </div>
        </div> -->
        <div class="card-wrap">
          <div class="card">
            <img src="./../assets/home/ni.png">
            <div class="card-title ">高安全</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img src="./../assets/home/performance.png">
            <div class="card-title ">高性能</div>
          </div>
        </div>
        <!-- <div class="card-wrap">
          <div class="card">
            <img src="./../assets/home/bing.png">
            <div class="card-title ">海量并发</div>
          </div>
        </div> -->
        <div class="card-wrap">
          <div class="card">
            <img
              src="./../assets/home/speed.png"
              class="border"
            >
            <div class="card-title ">灵活高效</div>
          </div>
        </div>
      </div>
    </section>
    <section class="help-warp">
      <div class="muhua-title ">可以帮你</div>
      <div class="card-content">
        <div class="card-wrap">
          <div class="card">
            <img
              class="border"
              src="./../assets/home/P2P.png"
              alt="沐桦科技"
            />
            <div class="help-title">构建P2P能力</div>
            <div class="help-content">通过海量分布式节点资源，解决用户在移动网络下构筑P2P能力的问题。</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              class="border"
              src="./../assets/home/improve.png"
              alt="沐桦科技"
            />
            <div class="help-title">提升业务性能</div>
            <div class="help-content">通过应用分布式网络的特性，提3G/4G网络的稳定性，从而保证P2P服务的稳定性。</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              class="border"
              src="./../assets/home/cost.png"
              alt="沐桦科技"
            />
            <div class="help-title">降低成本</div>
            <div class="help-content">高性价比的资源和技术，可帮助用户有效的降低成本。</div>
          </div>
        </div>
      </div>
    </section>
    <section class="product-detail">
      <div class="muhua-title advantage-title">了解产品详情</div>
      <div class="detail-wrap">
        <router-link to="/compute" class="button compute cursor-point">雾计算</router-link>
        <!-- <router-link to="/dynamic" class="button ip cursor-point">高质量动态代理</router-link> -->
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import Footer from "@/components/Footer.vue";
import Menu from "@/components/Menu.vue";
import Header from "@/components/Header.vue";

export default {
  name: "home",
  components: {
    Footer,
    Menu,
    Header
  },
  data() {
    return {
      activeIndex: "1",
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
      }
    };
  },
  computed: mapState({
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  }),
  created() {},
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    console.log("this is current swiper instance object", this.swiper);
    this.swiper.slideTo(3, 1000, false);
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    swiperMethod() {
      console.log(123);
    }
  }
};
</script>

<style scoped lang="stylus">
.blue-back {
  background: #f8fcff;
}

.partner {
  padding: 40px;
  display: flex;
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;

  .partner-each {
    width: 50%;
    height: 120px;
    display: inline-block;
    text-align: center;

    .industry {
      margin: 19px;
    }

    .compute {
      margin: 2.5px;
    }

    i, span {
      line-height: 120px;
      text-align: center;
      vertical-align: text-bottom;
      margin-left: 30px;
      color: #3f4f7c;
      font-size: 20px;
      font-weight: bold;
    }
  }
}

.banner {
  background: #282A3C;
  width: 100%;
  height: 512px;
  display: flex;

  .banner-content {
    width: 80%;
    margin: 0 auto;
    display: flex;
    max-width: 1200px;
  }

  .right-banner {
    width: 41%;

    img {
      height: 512px;
    }
  }

  .left-banner {
    width: 59%;

    .title {
      font-size: 32px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 45px;
      margin: 108px 0 34px 0;
    }

    .content {
      max-width: 500px;
      font-size: 18px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 30px;
      margin-bottom: 34px;
    }

    .know-more :hover {
      color: #00AEEF;
    }

    .know-more {
      width: 136px;
      height: 44px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      font-size: 11px;
      font-weight: 400;
      color: rgba(40, 42, 60, 1);
      line-height: 44px;
      text-align: center;
    }
  }
}

.compute-wrap {
  width: 100%;
  background: #FFFFFF;

  .compute-title {
    font-size: 20px;
    font-weight: 400;
    color: rgba(63, 80, 124, 1);
    line-height: 23px;
    margin: 34px auto;
    text-align: center;
  }

  .card-wrap {
    width: 25%;
    margin: 0px 20px 96px 20px;

    .card {
      width: 100%;
      max-width: 224px;
      height: 240px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      border: 1px solid rgba(63, 79, 124, 0.3);
      margin: 0 auto;
      text-align: center;

      img {
        width: 112px;
        height: 98px;
        margin: 31px 0 14px;
      }

      .title {
        font-size: 14px;
        font-weight: 400;
        color: rgba(63, 79, 124, 1);
        line-height: 20px;
        margin-bottom: 14px;
      }

      a {
        display: inline-block;
        width: 93px;
        height: 27px;
        border-radius: 2px;
        border: 1px solid rgba(0, 174, 239, 1);
        font-size: 9px;
        font-weight: 400;
        color: rgba(0, 174, 239, 1);
        line-height: 27px;
        margin-bottom: 20px;
      }

      .link-disabled {
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        border: 1px solid rgba(63, 79, 124, 0.3);
        color: rgba(197, 202, 215, 1);
      }
    }
  }

  .compute-content {
    display: flex;
    width: 80%;
    margin: 0 auto;
    max-width: 980px;
    justify-content: center;
    align-items: center;
  }
}

.advantage-wrap {
  background: rgba(248, 252, 255, 1);

  .card-content {
    display: flex;
    width: 80%;
    margin: 0 auto;
    max-width: 980px;
    justify-content:center;
    align-items:center;

    .card-wrap {
      width: 20%;

      .card {
        margin: 0 auto;
        text-align: center;
      }

      img {
        width: 120px;
        height: 120px;
        margin-botton: 14px;
      }

      .card-title {
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(63, 79, 124, 1);
        line-height: 20px;
        margin: 14px 0 98px;
      }
    }
  }
}

.help-warp {
  background: #FFFFFF;

  .card-content {
    display: flex;
    width: 80%;
    margin: 0 auto;
    max-width: 980px;

    .card-wrap {
      width: 33%;

      .card {
        margin: 0 auto;
        text-align: center;

        img {
          width: 70px;
          height: 70px;
        }

        .help-title {
          font-size: 18px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(63, 79, 124, 1);
          line-height: 36px;
          margin-top: 20px;
        }

        .help-content {
          font-size: 9px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(116, 133, 152, 1);
          line-height: 25px;
          max-width: 150px;
          margin: 9px auto 98px;
        }

        .button {
          width: 93px;
          height: 27px;
          background: rgba(0, 174, 239, 1);
          border-radius: 2px;
          border: 1px solid rgba(0, 174, 239, 1);
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 12px;
        }
      }
    }
  }
}

.product-detail {
  background-image: url('../assets/background/home-background.png');
  height: 222px;

  .detail-wrap {
    display: flex;
    justify-content: space-between;
    width: 327px;
    margin: 0 auto;
  }

  .advantage-title {
    font-size: 30px;
  }
}

.new-item, .one-item {
  display: flex;
}

.swiper-wrap{
  min-height: 240px;
}

.news-swiper{
  margin-bottom: 20px;
}

.new-item {
  margin-right: 20px;
  .news-image {
    width: 230px;
    height:200px
  }

  .new-right{
    margin-left: 20px;
  }

  .news-title {
    font-size: 16px;
    font-weight: 400;
    color: #3f4f7c;
    line-height: 24px;
  }

  .news-content {
    font-size: 12px;
    font-weight: 400;
    color: #748598;
    line-height: 25px;
    margin-top: 20px;
  }
}
.new-left{
  margin: 0 10px 20px;
}
.one-item{
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
}


@media screen and (min-width: 1920px) {
  .one-item{
    width: 85%;
  }
  .one-item a {
    margin: 20px 30px
  }

  .swiper-wrap{
    min-height: 280px
  }
}
</style>
